import { toast } from "@assetwatch/ui";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const TOAST_TIMEOUT_MS = 10_000;

export function MotionAmplificationRetryPrompt({
  open,
  jobName,
  isRetrying,
  onRetry,
  onDecline,
}: {
  open: boolean;
  jobName: string;
  isRetrying: boolean;
  onRetry: () => void;
  onDecline: () => void;
}) {
  const { t } = useTranslation();
  const onRetryRef = useRef(onRetry);
  const onDeclineRef = useRef(onDecline);
  onRetryRef.current = onRetry;
  onDeclineRef.current = onDecline;

  useEffect(() => {
    if (!open || isRetrying) return;

    toast.add(t("motionAmplification.retryToastDescription", { jobName }), {
      action: {
        label: t("motionAmplification.retryUpload"),
        onClick: () => {
          void onRetryRef.current();
        },
      },
      timeout: TOAST_TIMEOUT_MS,
      variant: "error",
    });

    const timeout = setTimeout(() => onDeclineRef.current(), TOAST_TIMEOUT_MS);
    return () => clearTimeout(timeout);
  }, [isRetrying, jobName, open, t]);

  return null;
}
